import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export type IAvatarUrl = {
  aspect_low: {
    urls: string[]
  }
  origin: {
    urls: string[]
  }
}

// export const privilegeTypeEnum = {
//   1: '背包礼物',
//   2: '专属礼物',
//   3: '头像框',
//   4: '勋章',
//   5: '气泡框',
//   6: '进场特效',
//   7: '专属客服',
//   8: '建房权限',
//   9: '查看访客权限',
// }

export type IPrivilegeInfo = {
  /**
   * 权益类型
   ** 1 - 背包礼物
   ** 2 - 专属礼物
   ** 3 - 头像框
   ** 4 - 勋章
   ** 5 - 气泡框x
   ** 6 - 进场特效
   ** 7 - 专属客服
   ** 8 - 建房权限
   ** 9 - 查看访客权限
   ** 10 - 升级飘屏
   ** 11 - 上线通知
   ** 12 - 身份标识
   ** 13 - 金主装扮
   */
  privilege_type: number
  /** 权益名称 */
  privilege_name: string
  /** 权益等级 */
  privilege_level: number
  /** 解锁等级 */
  unlock_level: number
  /** 权益icon */
  small_icon: string
  /** 大icon	 */
  big_icon: string
  /** 描述 */
  description: string
  /** 有效期，时间戳，秒，0=无有效期 */
  et: number
  /** 价值金币，0=无价值展示 */
  worth_coin: number
  worth_coin_display: number
  /** 是否领取，false表示未领取（目前就专属客服会默认为false */
  is_received: boolean
  /** 赋予时间，时间戳，秒 */
  grant_time: number
}

export type IWealthResp = {
  /** 头像 */
  avatar_urls: IAvatarUrl
  /** 昵称 */
  nickname: string
  /** 当前财富等级 */
  current_wealth_level: number
  /** 当前财富值 */
  current_wealth_value: number
  current_wealth_value_display: number
  /** 当前等级最大财富值 */
  level_max_wealth_value: number
  level_max_wealth_value_display: number
  /** 升级下一级剩余金币 */
  upgrade_surplus_coin: number
  upgrade_surplus_coin_display: number
  /** 等级勋章url */
  level_medal_url: string
  /** 等级标签url */
  level_tag_url: string
  /** array(privilege_info)	数组，已解锁特权	 */
  unlock_privilege: IPrivilegeInfo[]
  /** array(privilege_info)	数组，未解锁特权  */
  locked_privilege: IPrivilegeInfo[]
  buff_info: IBufInfo
}

export type IBufInfo = {
  active: boolean
  buf_rate: number
  et: number
  rule_type: number // 1 固定buff，2 梯度buff
  match_act: boolean
  next_rule_coin: number
  next_rule_ratio: number
}

export const trade_wealth_detail = createAsyncThunk(
  '/live/account/trade_wealth_detail',
  async (_params, store: any) => {
    const resp = await http.post<{data: IWealthResp}>(
      `/live/account/trade_wealth_detail`,
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)

/** /live/privilege/update_private_service 绑定客服 */
export const update_private_service = createAsyncThunk(
  '/live/privilege/update_private_service',
  async (whatsapp: string, store: any) => {
    const resp = await http.post<{data: any}>(
      `/live/privilege/update_private_service`,
      {
        ...store.getState().env.deviceinfo,
        whatsapp,
      }
    )

    return resp.data.data
  }
)

const initialState: IWealthResp = {
  avatar_urls: {
    aspect_low: {
      urls: [],
    },
    origin: {
      urls: [],
    },
  },
  nickname: '',
  current_wealth_level: 0,
  current_wealth_value: 0,
  current_wealth_value_display: 0,
  level_max_wealth_value: 0,
  level_max_wealth_value_display: 0,
  upgrade_surplus_coin: 0,
  upgrade_surplus_coin_display: 0,
  level_medal_url: '',
  unlock_privilege: [],
  locked_privilege: [],
  level_tag_url: '',
  buff_info: null,
}

export const WealthLevelSlice = createSlice({
  name: 'WealthLevel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(trade_wealth_detail.fulfilled, (state, action) => {
      const {
        avatar_urls,
        nickname,
        current_wealth_level,
        current_wealth_value,
        current_wealth_value_display,
        level_max_wealth_value,
        level_max_wealth_value_display,
        upgrade_surplus_coin,
        upgrade_surplus_coin_display,
        level_medal_url,
        unlock_privilege,
        locked_privilege,
        level_tag_url,
        buff_info,
      } = action.payload

      Object.assign(state, {
        avatar_urls,
        nickname,
        current_wealth_level,
        current_wealth_value,
        current_wealth_value_display,
        level_max_wealth_value,
        level_max_wealth_value_display,
        upgrade_surplus_coin,
        upgrade_surplus_coin_display,
        level_medal_url,
        unlock_privilege,
        locked_privilege,
        level_tag_url,
        buff_info,
      })
    })

    // builder.addCase(update_private_service.fulfilled, (state, action) => {
    //   // do nothing
    // })
  },
})

export default WealthLevelSlice.reducer

export const WealthLevelAction = WealthLevelSlice.actions
export const useWealthLevelState = () =>
  useSelector((state) => state.WealthLevel)
